import React from "react";
import {
  collection,
  getDocs,
  addDoc,
  setDoc,
  doc
} from "firebase/firestore";
import { db } from "../firebase";
import {buttons} from "../styles/tokens";

export default function QuickAddButton({
  user,
  videoId,
  videoTitle,
  playerRef,
  reloadCallback,
  offset = 3,
  onSuccess
}) {
  const handleQuickAdd = async () => {
    if (!user || !videoId || !playerRef?.current?.getCurrentTime) {
      alert("Missing user, video, or player reference");
      return;
    }

    const currentTime = playerRef.current.getCurrentTime();
    const start = Math.max(0, currentTime - offset);
    const end = currentTime;
    const speed = 1.0;

    try {
      const bookmarksRef = collection(
        db,
        "users",
        user.uid,
        "videos",
        videoId,
        "bookmarks"
      );

      const snapshot = await getDocs(bookmarksRef);
      const sectionCount = snapshot.docs.filter(doc =>
        (doc.data().title || "").startsWith("Section")
      ).length;

      const title = `Section ${sectionCount + 1}`;

      const videoDocRef = doc(db, "users", user.uid, "videos", videoId);
      await setDoc(videoDocRef, { title: videoTitle || "Untitled Video" }, { merge: true });

      const docRef = await addDoc(bookmarksRef, {
        title,
        videoId,
        videoTitle,
        start,
        end,
        speed,
        uid: user.uid
      });

      await setDoc(docRef, { id: docRef.id }, { merge: true });

      if (onSuccess) onSuccess();
      reloadCallback?.();
    } catch (err) {
      console.error("Error during quick add:", err);
    }
  };

  return (
    <button
      onClick={handleQuickAdd}
      className={buttons.activePurpleSm}
    >
      Add Section
    </button>
  );
}
